exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iconModify[data-v-28bd0b6a] {\n  right: 0;\n  top: 0;\n  position: absolute;\n  height: 32px;\n}\n.my-icon[data-v-28bd0b6a] {\n  margin: 9px 7px;\n  display: inline-block;\n  text-align: center;\n  color: #666;\n}\n.my-icon i[data-v-28bd0b6a] {\n    font-size: 36px;\n    vertical-align: middle;\n    fill: currentColor;\n    overflow: hidden;\n}\n", ""]);

// exports
